module.exports = __webpack_public_path__ + "static/media/tn.a8755943.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/tn.svg
// module id = 2228
// module chunks = 0